import { render, staticRenderFns } from "./AcuerdoPago.vue?vue&type=template&id=23af10e5&"
import script from "./AcuerdoPago.vue?vue&type=script&lang=js&"
export * from "./AcuerdoPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports